'use client';

import React, { useState } from 'react';

import ShareIcon from '@mui/icons-material/Share';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Stack, Paper, Button, TextField, Typography, IconButton } from '@mui/material';

export default function LinkGenerator() {
  const [projectLink, setProjectLink] = useState('');
  const [generatedLinks, setGeneratedLinks] = useState({
    customer: '',
    agent: '',
  });

  const handleGenerateLink = () => {
    if (!projectLink) return;
    setGeneratedLinks({
      customer: `${projectLink}/customer`,
      agent: `${projectLink}/agent`,
    });
  };

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const handleDelete = () => {
    setGeneratedLinks({ customer: '', agent: '' });
  };

  return (
    <Box py={3}>
      <Typography variant="subtitle2" mb={1}>
        Link Generation
      </Typography>

      <Stack direction="row" spacing={2} mb={4}>
        <TextField
          fullWidth
          placeholder="Insert Link to Project"
          value={projectLink}
          onChange={(e) => setProjectLink(e.target.value)}
          InputProps={{
            endAdornment: (
              <Button
                sx={{ borderRadius: 10, width: '200px' }}
                color="info"
                size="small"
                variant="contained"
                onClick={handleGenerateLink}
              >
                Generate Link
              </Button>
            ),
          }}
        />
      </Stack>

      {/* {generatedLinks.customer && ( */}
      <>
        <Typography variant="subtitle2" mb={1}>
          Generated Links
        </Typography>

        <Stack spacing={2}>
          {/* Customer Link */}
          <Paper variant="outlined" sx={{ display: 'flex', alignItems: 'center', p: 1.5 }}>
            <Stack flex={1}>
              <Typography variant="caption">Customer Affiliate Link</Typography>
              <Typography variant="body2" noWrap>
                {generatedLinks.customer}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Button
                size="small"
                variant="contained"
                sx={{ bgcolor: '#8a2be2', borderRadius: 10, width: '100px' }}
                onClick={() => handleCopy(generatedLinks.customer)}
              >
                Copy Link
              </Button>
              <IconButton onClick={handleDelete}>
                <DeleteIcon />
              </IconButton>
              <IconButton>
                <ShareIcon />
              </IconButton>
            </Stack>
          </Paper>

          {/* Agent Link */}
          <Paper variant="outlined" sx={{ display: 'flex', alignItems: 'center', p: 1.5 }}>
            <Stack flex={1}>
              <Typography variant="caption">Agent Affiliate Link</Typography>
              <Typography variant="body2" noWrap>
                {generatedLinks.agent}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Button
                size="small"
                variant="contained"
                sx={{ bgcolor: '#8a2be2', borderRadius: 10, width: '100px' }}
                onClick={() => handleCopy(generatedLinks.agent)}
              >
                Copy Link
              </Button>
              <IconButton onClick={handleDelete}>
                <DeleteIcon />
              </IconButton>
              <IconButton>
                <ShareIcon />
              </IconButton>
            </Stack>
          </Paper>
        </Stack>
      </>
      {/* )} */}
    </Box>
  );
}
